import {
  supportAnalyticsInputSchema,
  supportAnalyticsOutputSchema,
} from "@redotech/redo-model/support/analytics/support-analytics-schemas";

export const supportAnalytics = {
  name: "supportAnalytics" as const,
  input: supportAnalyticsInputSchema,
  output: supportAnalyticsOutputSchema,
};
